import React from 'react'
import ErrorPage from '../../components/ErrorPage'

const Error403 = () => (
  <ErrorPage
    statusCode={403}
    icon="ban"
    title="このページを表示する権限がありません"
    action="解決しない場合は、担当者にお問い合わせください。"
  />
)

export default Error403
